import * as transportZonesModule from './zones/transport-zones.module';
import * as transportLoactionsUploadModule from './upload/transport-locations-upload.module';

export const initialise = () => {
  angular.module('app.transport-locations', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ]);

  transportZonesModule.initialise();
  transportLoactionsUploadModule.initialise();
};